module.exports = __webpack_public_path__ + "img/itx-file-type-rtf.1efb510e.svg";